import DetailsLogSectionSidebar from '@/components/modals/workflowLogsModal/DetailsLogSectionSidebar';
import EmptyStateNotice from '@/components/EmptyStateNotice';
import WorkflowLogsColumnResizer from '@/components/modals/workflowLogsModal/WorkflowLogsColumnResizer';
import Page from '@/components/page/Page';
import Skeleton from '@/components/Skeleton';
import { getUserIdentity } from '@/redux/actions/userActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import LogStepOutput from '@/screens/workflows/workflowLogs/LogStepOutput';
import LogSteps from '@/screens/workflows/workflowLogs/LogSteps';
import LogWorkDone from '@/screens/workflows/workflowLogs/LogWorkDone';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const DetailsLogSection = () => {
  const [manualUser, setManualUser] = useState(null);
  const loading = useArgSelector(selectors.isLoading, 'getWorkflowLogOutput');
  const selectedTab = useArgSelector(selectors.query, 'logTab') || 'timeline';
  const isLoadingLogById = useArgSelector(selectors.isLoading, 'getWorkflowLogById');
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const activeLog = useArgSelector(selectors.workflowLogsById, activeLogId);
  const invokedBy = useSelector((state) => selectors.workflowLogsById(state, activeLogId)?.meta?.invokedBy);
  const manualUserId = invokedBy?.startsWith('manual-') ? invokedBy?.split('-')[1] : null;

  useEffect(() => {
    if (manualUserId) {
      getUserIdentity({ userId: manualUserId }).then((user) => setManualUser(user));
    } else {
      setManualUser(null);
    }
  }, [manualUserId]);

  if (isLoadingLogById) {
    return (
      <Page.Section variant="chromeless" className="details-log-section">
        <Skeleton skeletonStyle={{ height: '100%', borderRadius: 6 }} containerStyle={{ padding: 0 }} />
      </Page.Section>
    );
  }

  if (activeLog?.meta?.logUploadStatus === 'uploading') {
    return (
      <Page.Section variant="chromeless" className="details-log-section">
        <div className="log-upload-status" role="status">
          <EmptyStateNotice loading title="Uploading logs" description="Execution has finished. The timeline will be available when the log upload completes." />
        </div>
      </Page.Section>
    );
  }

  return (
    <Page.Section variant="chromeless" className="details-log-section">
      <DetailsLogSectionSidebar />
      {selectedTab === 'timeline' && (
        <>
          <LogSteps loading={loading} invokedBy={invokedBy} manualUser={manualUser} manualUserId={manualUserId} />
          <WorkflowLogsColumnResizer label="Resize workflow log timeline" widthProperty="--workflow-log-timeline-width" minWidth={240} minFollowingWidth={320} preferenceKey="pane-width-workflow-logs-timeline" />
          <LogStepOutput invokedBy={invokedBy} manualUser={manualUser} manualUserId={manualUserId} />
        </>
      )}
      {(selectedTab === 'errors' || selectedTab === 'warnings' || selectedTab === 'successes') && <LogWorkDone />}
    </Page.Section>
  );
};

export default DetailsLogSection;
